import {
  GET_POPULARORPERSONAL_EVENTS_REQUEST,
  GET_POPULARORPERSONAL_EVENTS_SUCCESS,
  GET_POPULARORPERSONAL_EVENTS_FAILURE } from 'Store/constants';
  
export const initialState = {
  isLoading: true,
  isFetched: false,
  data: []
};

export default (state = initialState, action) => {

  switch (action.type) {

    case GET_POPULARORPERSONAL_EVENTS_REQUEST: {
      const { isPersonal } = action.payload;
      return {
        ...state,
        isLoading: true,
        isFetched: false,
        isPersonal: isPersonal
      };
    }

    case GET_POPULARORPERSONAL_EVENTS_SUCCESS: {
      const { data, isPersonal } = action.payload;
      return {
        ...state,
        data: data,
        isLoading: false,
        isFetched: true,
        isPersonal: isPersonal
      };
    }

    case GET_POPULARORPERSONAL_EVENTS_FAILURE: {
      const { isPersonal } = action.payload;
      return {
        ...state,
        isLoading: false,
        isFetched: true,
        isError: true,
        isPersonal: isPersonal
      };
    }
  
  
    default:
      return state;
  }
};
  